/**
 * If changing the page paths, remember to change the folder name in the app folder as well.
 */
export const ARTICLES_PAGE_PATH = '/nyheter';
export const COMPLAINT_GUIDE_PAGE_PATH = '/klageveileder';
export const INSURANCE_PAGE_PATH = '/forsikring';
export const COLLECTION_PAGE_PATH = '/inkasso';
export const BANK_PAGE_PATH = '/bank';
export const FAQ_PAGE_PATH = '/ofte-stilte-sporsmal';
export const ABOUT_PAGE_PATH = '/om-oss';
export const SEARCH_PAGE_PATH = '/sok';
export const FINANCE_PAGE_PATH = '/for-finansforetak';
export const FOR_LAWYERS_PAGE_PATH = '/for-advokater';
export const LOGIN_PAGE_PATH = '/logg-inn';

export const COMPANIES_PAGE_PATH = `${ABOUT_PAGE_PATH}/tilsluttede-foretak`;

export const NEMND_PAGE_PATH = `${ABOUT_PAGE_PATH}/nemndene`;

export const INSURANCE_GUIDEBOOK_PATH = `${INSURANCE_PAGE_PATH}/klageguide`;
export const COLLECTION_GUIDEBOOK_PATH = `${COLLECTION_PAGE_PATH}/klageguide`;
export const BANK_GUIDEBOOK_PATH = `${BANK_PAGE_PATH}/klageguide`;

export const SITE_NAME = 'Finansklagenemnda';

// The number of articles to fetch per page
export const ARTICLE_PAGE_SIZE = 6;
